const LocationRetryPrompt = ({
  isLoadingLocation = false,
  permissionDenied = false,
  locationError = null,
  onRetryLocation,
  title = "Live Location Required",
  description = "To discover clubs near you, we need access to your real-time location. Nearby results use your live GPS coordinates.",
}) => (
  <div className="location-retry-panel">
    <div className="location-retry-icon">
      <i className="fa fa-map-marker" aria-hidden="true" />
    </div>
    <h3>{title}</h3>
    <p className="location-retry-copy">{description}</p>
    {isLoadingLocation ? (
      <p className="location-retry-message location-retry-message--muted">
        Requesting your current location from the browser...
      </p>
    ) : permissionDenied ? (
      <p className="location-retry-message">
        Your browser has blocked location access. Please allow location permission from the browser address bar or settings, then retry.
      </p>
    ) : locationError ? (
      <p className="location-retry-message">{locationError}</p>
    ) : null}

    <button
      type="button"
      className="btn btn-primary location-retry-button"
      onClick={onRetryLocation}
      disabled={isLoadingLocation}
    >
      <i className="fa fa-location-arrow" aria-hidden="true" />
      {isLoadingLocation
        ? "Requesting Location..."
        : permissionDenied
          ? "Retry Location Access"
          : "Enable Location Access"}
    </button>
  </div>
);

export default LocationRetryPrompt;
